import { render, staticRenderFns } from "./index.vue?vue&type=template&id=7e561e46&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/__w/one-stop-shop/one-stop-shop/one-stop-shop/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7e561e46')) {
      api.createRecord('7e561e46', component.options)
    } else {
      api.reload('7e561e46', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=7e561e46&", function () {
      api.rerender('7e561e46', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "web/wp-content/themes/global-theme/views/pages/productAside/Messages/index.vue"
export default component.exports